import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";

import { MaterialCard } from "@learningblocks/simulations/shared-components";
import { RectangleCard } from "@learningblocks/storybook-components";
import { getImageData } from "./component_data";

import style from "./style.module.scss";

class MaterialSectionBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      materials: [],
    };
  }

  buildComponent = (data, index) => {
    if (this.props.displayAsList) {
      return this.buildListCard(data, index);
    }
    return this.buildMaterialCard(data, index);
  };

  buildListCard = (data, index) => {
    const glossaryId = data.props.contentID ? data.props.contentID : "";
    const carddata = {
      key: index + "_" + data.props.type + "_" + data.component,
      trim: false,
      id: data.props.id,
      title: data.props.fullName,
      description: data.props.description,
      ariaLabel: Object.hasOwn(data.props, "ariaLabel")
        ? data.props.ariaLabel
        : "",
      isSolutionTube: Object.hasOwn(data.props, "solutionTube") ? true : false,
      solutionTube: Object.hasOwn(data.props, "solutionTube")
        ? data.props.solutionTube
        : {},
      glossaryId: glossaryId,
      image: Object.hasOwn(data.props, "solutionTube")
        ? null
        : getImageData(data.component, data.props),
    };
    return (
      <RectangleCard
        {...carddata}
        removeOption={true}
        className={glossaryId ? "" : style.noGlossary}
      />
    );
  };

  buildMaterialCard = (data, index) => {
    const carddata = {
      key: index + "_" + data.props.type + "_" + data.component,
      id: data.props.id,
      fullName: data.props.fullName,
      description: data.props.description,
      ariaLabel: Object.hasOwn(data.props, "ariaLabel")
        ? data.props.ariaLabel
        : "",
      isSolutionTube: Object.hasOwn(data.props, "solutionTube") ? true : false,
      solutionTube: Object.hasOwn(data.props, "solutionTube")
        ? data.props.solutionTube
        : {},
      contentID: "",
      image: Object.hasOwn(data.props, "solutionTube")
        ? null
        : getImageData(data.component, data.props),
    };
    return <MaterialCard {...carddata} />;
  };

  componentDidMount() {
    this.doCompPart(this.props.materials, this.props.groups);
  }

  doCompPart = (data, groups) => {
    const groupArr = [];

    Object.keys(groups).forEach((key, index) => {
      const compArr = [];
      groups[key].components.forEach((component) => {
        if (Object.hasOwn(data, component)) {
          if (component == "CellSpreader") {
            compArr.push(this.buildComponent(data[component].components[0], 0));
          } else {
            data[component].components.forEach((comp, index) => {
              if (comp["component"] == "Solution") {
                if (!Object.hasOwn(groups[key], "type")) {
                  compArr.push(this.buildComponent(comp, index));
                } else if (
                  groups[key]["type"] == "Filled" &&
                  comp["props"]["volume"] > 0
                ) {
                  compArr.push(this.buildComponent(comp, index));
                } else if (
                  groups[key]["type"] == "Empty" &&
                  comp["props"]["volume"] == 0
                ) {
                  compArr.push(this.buildComponent(comp, index));
                }
              } else {
                compArr.push(this.buildComponent(comp, index));
              }
            });
          }
        }
      });

      if (typeof compArr[0] != "undefined") {
        groupArr.push(
          <div aria-label={key} key={index} className={style.Category}>
            <h3 aria-label={key} className={style.CategoryHeading}>
              <FormattedMessage id={key} defaultMessage={key} description="" />
              {}
            </h3>
            <h6 className={style.CategoryDescription}>
              {groups[key].description &&
                this.props.intl.formatMessage({
                  id: groups[key].description,
                  defaultMessage: groups[key].description,
                  description: "",
                })}
            </h6>
            <div aria-label={key} className={style.Group}>
              {compArr}
            </div>
          </div>
        );
      }
    });

    this.setState({
      materials: groupArr,
    });
  };

  render() {
    return (
      <div className={style.Materials} dir="auto">
        {this.props.helperText && (
          <p className={style.HelperText}>
            {this.props.intl.formatMessage({
              id: this.props.helperText,
              defaultMessage: this.props.helperText,
              description: "",
            })}
          </p>
        )}
        {this.state.materials}
      </div>
    );
  }
}

MaterialSectionBase.propTypes = {
  materials: PropTypes.object.isRequired,
  helperText: PropTypes.string,
  groups: PropTypes.object.isRequired,
};

export const MaterialSection = injectIntl(MaterialSectionBase);
